// extracted by mini-css-extract-plugin
module.exports = {"graphContainer":"Chart_Village_Gender_LineChart_graphContainer__1cgzR"};